/* eslint-disable @typescript-eslint/ban-ts-comment */

import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { StatusFieldOption } from 'api/tasks';
import { Menu as MenuAtom } from 'components/atoms/dropdown';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { StatusPickerOption } from './option';

const styles = (width = 240) => ({
  control: (base) => ({
    ...base,
    width,
    margin: 0,
    border: '0',
    borderRadius: 0,
    minHeight: 0,
    height: 0,
    boxShadow: 'none',
  }),
  menu: () => ({
    boxShadow: 'none',
    paddingTop: '0',
  }),
  menuList: () => ({
    padding: 0,
    maxHeight: '500px',
    overflow: 'auto',
  }),
  placeholder: (base) => ({ ...base }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    paddingLeft: '16px',
    minHeight: 0,
    height: 0,
    opacity: 0,
  }),
});

type Status = StatusFieldOption;

interface Props extends ClassNameOnlyProps {
  header: ReactNode;
  onChange: (selected: Status) => void;
  value: Status;
  options: Status[];
  width?: number;
}

const Menu = styled(MenuAtom)`
  width: max-content;
  && {
    box-shadow: var(--shadow-08);
  }
`;

export const StatusPickerOverlay: FC<Props> = ({
  header,
  onChange,
  value,
  options,
  width,
  className,
}) => (
  /* added ant-dropdown-menu class for some of the ant styles to apply here */
  <Menu className={classNames('ant-dropdown-menu', className)}>
    <div
      tabIndex={0}
      role="listbox"
      onKeyPress={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <MenuAtom.Header>{header}</MenuAtom.Header>
      {/* TODO:: FIX_SELECT */}
      {/* @ts-ignore */}
      <Select
        classNamePrefix="status-picker"
        isSearchable={false}
        autoFocus
        backspaceRemovesValue={false}
        components={{
          Option: StatusPickerOption,
          DropdownIndicator: null,
          IndicatorSeparator: null,
          Input: null,
        }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={onChange}
        options={options}
        getOptionLabel={(option) => option.label}
        placeholder="Search..."
        styles={styles(width)}
        tabSelectsValue={false}
        value={value}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary: 'var(--primary-color)',
          },
        })}
      />
    </div>
  </Menu>
);
